import React from "react";

const Eye = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_950_48)">
        <path
          d="M24.8646 12.3124C22.5108 7.72 17.8511 4.61279 12.5156 4.61279C7.1801 4.61279 2.51907 7.72217 0.166643 12.3129C0.0673556 12.5093 0.015625 12.7263 0.015625 12.9463C0.015625 13.1664 0.0673556 13.3834 0.166643 13.5798C2.52038 18.1723 7.1801 21.2795 12.5156 21.2795C17.8511 21.2795 22.5121 18.1701 24.8646 13.5794C24.9638 13.383 25.0156 13.166 25.0156 12.9459C25.0156 12.7258 24.9638 12.5088 24.8646 12.3124ZM12.5156 19.1961C11.2795 19.1961 10.0711 18.8296 9.04329 18.1428C8.01548 17.4561 7.2144 16.4799 6.74135 15.3379C6.26831 14.1959 6.14454 12.9392 6.38569 11.7268C6.62685 10.5144 7.22211 9.40079 8.09618 8.52671C8.97026 7.65263 10.0839 7.05738 11.2963 6.81622C12.5087 6.57506 13.7653 6.69883 14.9074 7.17188C16.0494 7.64493 17.0255 8.446 17.7123 9.47381C18.399 10.5016 18.7656 11.71 18.7656 12.9461C18.766 13.767 18.6046 14.5799 18.2907 15.3384C17.9767 16.0968 17.5164 16.786 16.9359 17.3664C16.3555 17.9469 15.6663 18.4072 14.9078 18.7212C14.1494 19.0351 13.3365 19.1965 12.5156 19.1961ZM12.5156 8.77946C12.1437 8.78466 11.7742 8.83999 11.4171 8.94396C11.7114 9.34399 11.8527 9.83627 11.8152 10.3315C11.7778 10.8268 11.5641 11.2922 11.2129 11.6434C10.8617 11.9946 10.3962 12.2083 9.90099 12.2458C9.40574 12.2832 8.91346 12.142 8.51343 11.8476C8.28564 12.6868 8.32676 13.5764 8.631 14.391C8.93524 15.2056 9.48729 15.9044 10.2094 16.3888C10.9316 16.8733 11.7875 17.1191 12.6566 17.0916C13.5258 17.0642 14.3645 16.7648 15.0546 16.2358C15.7447 15.7067 16.2516 14.9745 16.5038 14.1423C16.756 13.3101 16.7409 12.4197 16.4606 11.5965C16.1803 10.7734 15.6489 10.0588 14.9412 9.55347C14.2335 9.04812 13.3852 8.77741 12.5156 8.77946Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_950_48">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(0.015625 0.446045)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Eye;
